import { AlignJustifyButton } from './AlignJustifyButton'
import { AlignRightButton } from './AlignRightButton'
import { AlignCenterButton } from './AlignCenterButton'
import { AlignLeftButton } from './AlignLeftButton'
import Styles from 'common/Prose/Toolbar/ToolbarBravo/SingleMenuDropdown/SingleMenuDropdown.module.scss'
import { IndentInButton } from './IndentInButton'
import { IndentOutButton } from './IndentOutButton'
import { ColumnsButtons } from './ColumnsButtons'
import { SimpleDropdown } from '../SimpleDropdown/SimpleDropdown'
import { IconName, ToolbarIcon } from 'common/Prose/Toolbar/ToolbarIcon'

export const AlignmentDropdown = () => (
  <SimpleDropdown
    tooltip={{ label: 'Select alignment' }}
    label="Alignment dropdown"
    bodyClassName={Styles.dropdownBody}
  >
    <ToolbarIcon name={IconName.AlignLeft} />
    <>
      <AlignLeftButton />
      <AlignCenterButton />
      <AlignRightButton />
      <AlignJustifyButton />
      <span className={Styles.lineDivider} />
      <IndentInButton />
      <IndentOutButton />
      <span className={Styles.lineDivider} />
      <ColumnsButtons />
    </>
  </SimpleDropdown>
)
